"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const svg_1 = require("components/atoms/svg");
const customDiffCell = ({ dataIndex, dataItem, field, style }) => {
    const itemData = dataItem;
    const rowColor = [6, 10, 14, 15].includes(dataIndex + 1);
    return ((0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 1, role: 'gridcell', "aria-selected": 'false', "aria-colindex": dataIndex, "data-grid-col-index": dataIndex, className: 'k-grid-content-sticky', id: `m_grid_cell_${field}_${dataIndex}`, style: Object.assign(Object.assign({}, style), { fontSize: 14, color: '#FFFFFF', backgroundColor: rowColor ? '#727272' : '#B5B5B5' }) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'space-between'
            } }, { children: [field && itemData[field] > 0 ? (0, jsx_runtime_1.jsx)(svg_1.UpIcon, {}) : (0, jsx_runtime_1.jsx)(svg_1.DownIcon, {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { marginLeft: 10 } }, { children: field && Math.abs(itemData[field]).toString() }))] })) })));
};
exports.default = customDiffCell;
